export default __webpack_public_path__ + "static/media/profile.847b30c8.png";